module.exports = "../fonts/HelveticaNeueLTW01-56Italic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-56Italic.woff2
// module id = NJMj
// module chunks = 1